import { getDefaultStore } from "jotai";
import { captureEvent } from "@sentry/nextjs";
import { userSettingsAtom } from "../atoms";
import { appNoteStore } from "../services";
import { upsertUserSettings } from "../userSettings";
import { ApiClient } from "../../api/client";
import { IdeaflowUser } from "../../auth/useAuth";
import { makeUserSettings } from "../defaults";
import logger from "../../utils/logger";
import { Note } from "../../../shared/types";
import { fixTopLevelTokens } from "../../export/fixTokens";
import { getDefaultNotes } from "../defaultNotes";

// TODO: this is a bit of a hack, we should have a better model for this so that hashtag renames
// don't have to go through NoteStore to begin with.
// But for now this utility function makes sure that the update in both NoteStore and UserSettings always run together
// as part of the rename without making NoteStore import UserSettings which causes a circular dependency.
export const renameHashtag = (oldHashtag: string, newHashtag: string) => {
  appNoteStore.renameHashtag(oldHashtag, newHashtag);

  // Check if the hashtag is pinned and update it in the user settings if so
  const { pinnedHashtags } = getDefaultStore().get(userSettingsAtom);
  if (pinnedHashtags.find((h) => h.id === oldHashtag)) {
    pinnedHashtags.find((h) => h.id === oldHashtag)!.id = newHashtag;
    upsertUserSettings({ pinnedHashtags });
  }
};

export async function createUserAndThoughtstream(user: IdeaflowUser) {
  const { id, email, first_name, last_name } = user;
  const userSettings = makeUserSettings();
  //Todo: This should be moved to server side,
  // if server has a valid JWT token but no user in DB, create an account
  await ApiClient().users.create({
    id,
    email,
    firstName: first_name,
    lastName: last_name,
    settings: userSettings,
  });
  const { notes, folders } = getDefaultNotes(id);
  const responses = await Promise.allSettled([ApiClient().users.createDefaultNotes()]);

  // Log any errors
  responses.forEach((response) => {
    if (response.status === "rejected") {
      logger.error("Error during user creation", { error: response.reason, context: { userId: user.id } });
    } else if (response.value.status !== true) {
      logger.error("Error during user creation", {
        error: "Error during user creation",
        context: { userId: user.id, stats: response.value.status },
      });
    }
  });

  // TODO : do we need to log analytics events in Sentry?
  captureEvent({
    message: `New user: ${id}`,
    tags: { category: "new-user" },
    level: "info",
    fingerprint: ["new-user", id],
  });
  return { notes, folders, userSettings };
}

export const migrateNote = (note: Note) => {
  note.tokens = fixTopLevelTokens(note.tokens);
  return note;
};
